module.exports = __webpack_public_path__ + "img/gorock_banner.e8496bba.png";